import { createApp } from 'vue'
import App from './App.vue'
import '../../assets/css/boxicons.min.css';

createApp(App).mount('#app')
